<template>
    <div class="playerSelection" v-bind:class="{ darkmode: darkmode }">
        <div class="players">
            <div v-for="player in players" class="player" @click="$emit('player-chosen', player)">{{ player.name }}</div>
        </div>
    </div>

    

</template>

<script>

import axios from 'axios'

export default {

    name: 'PlayerSelection',

    data() {
        return {

            players: [],
        }
    },

    props: ['darkmode'],
    
    methods: {
        loadUsers() {
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/users/get_enabled_users.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    self.players.push(response.data[i]);

                }
            }).catch(function (error) {
                console.log(error);
            });
        },

    },

    mounted() {
        this.loadUsers();
        this.$root.$on('reload-players', () => {
            this.players = [];
            this.loadUsers();
        });
    }

}
</script>


<style scoped>

    

    * {
    
        box-sizing: border-box;
    }

    .playerSelection {
        position: absolute;
        width: 800px;
        height: 390px;
        top: 90px;
        /*background: rgba(0,0,0,0.7);*/
        background: #fff;
        z-index: 10;
        color: white;
    }

    .darkmode {
        background: #444;
    }

    .players {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 16px;
        /*height: 390px;*/
        /*flex-direction: column;*/
        /*justify-content: center;*/
        /*padding: 10px;*/
    }

    .player {
        /*flex: 0 0 auto;*/

        width: 180px;
        height: 60px;
        margin-top: 16px;
        margin-left: 16px;
        font-size: 24px;
        border: 1px solid #aaa;
        padding: 10px 10px 8px;
        text-align: center;
        overflow: hidden;
        word-break: break-word;
        /*background: #222;*/
        background: #eee;
        /*color: #fff;*/
        color: #000;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        /*text-transform: uppercase;*/
        user-select: none;
        cursor: pointer;

        display: flex;
        padding: 0;
        align-items: center;
        justify-content: center;
    }

</style>
